
const shiftFormSubmitted = () => {
    return(
     <div style={{margin: "30px 7%"}}>
       <p>シフトを提出しました。</p> 
     </div>   
    ) 
 }
 
 export default shiftFormSubmitted;